import React, { useEffect, useState } from 'react'
import { loadingState } from 'src/atom/LoadingState'
import { useRecoilState } from 'recoil'
import { globalStream } from 'src/atom/GlobalStream'
import { useNavigate } from 'react-router-dom'
import { sendOtp } from 'src/services/PreRegistration/PreRegistration'
import LogoHeader from 'src/components/header/LogoHeader'
import { CURRENT_SESSION } from 'src/utils/counsellingDates'

const RegistrationDetails = () => {
  const [GSteam, setGlobalSteam] = useRecoilState(globalStream)
  const registrationObject = {
    counsellingName: `${GSteam.counsellingName}`,
    rollno: `${GSteam.neetRollNumber}`,
    email: `${GSteam.email}`,
    phoneNumber: `${GSteam.mobileNumber}`
  }

  const [formData, setFormData] = useState(registrationObject)
  const [errors, setErrors] = useState({})
  const [loader, enableLoader] = useRecoilState(loadingState)
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Validation functions
  const validateForm = () => {
    const newErrors = {}
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const phoneRegex = /^[6-9]\d{9}$/ // Indian mobile number format
    const nameRegex = /^[a-zA-Z\s]{2,50}$/

    // Validate when form fields are shown
    if (formData.phoneNumber === "null" || formData.email === "null" || formData.counsellingName === "Post Diploma DNB") {
      if (!formData.name) {
        newErrors.name = 'Name is required'
      } else if (!nameRegex.test(formData.name)) {
        newErrors.name = 'Name should be 2-50 characters long and contain only letters'
      }

      if (!formData.fatherName) {
        newErrors.fatherName = 'Father\'s name is required'
      } else if (!nameRegex.test(formData.fatherName)) {
        newErrors.fatherName = 'Father\'s name should be 2-50 characters long and contain only letters'
      }

      if (!formData.motherName) {
        newErrors.motherName = 'Mother\'s name is required'
      } else if (!nameRegex.test(formData.motherName)) {
        newErrors.motherName = 'Mother\'s name should be 2-50 characters long and contain only letters'
      }

      if (!formData.dob) {
        newErrors.dob = 'Date of birth is required'
      }

      if (!formData.gender) {
        newErrors.gender = 'Gender is required'
      }
    }

    // Validate email
    if (!formData.email || formData.email === "null") {
      newErrors.email = 'Email is required'
    }
    else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address'
    }

    // Validate mobile number
    if (!formData.phoneNumber || formData.phoneNumber === "null") {
      newErrors.phoneNumber = 'Mobile number is required'
    }
    else if (!phoneRegex.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Please enter a valid 10-digit mobile number starting with 6-9'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const sendOtpAll = async () => {
    if (!validateForm()) {
      return
    }
    enableLoader(true)
    const sendVerificationOTP = async () => {
      setIsSubmitting(true)
      enableLoader(true)
      var response = await sendOtp(formData)
      if (response.success) {
        setIsSubmitting(false)
        const id = response.body.id
        navigate('/OTPScreen', { state: { id } })
        enableLoader(false)
      } else {
        setIsSubmitting(false)
        enableLoader(false)
        alert(response.message)
      }
    }
    sendVerificationOTP()
  }

  const handleSubmit = () => {
    sendOtpAll()
  }

  useEffect(() => {
    if (!formData.rollno) {
      navigate('/homepage')
    }
  }, [formData.rollno])

  const phoneNumber = formData?.phoneNumber
  const maskedNumber = phoneNumber && phoneNumber !== "null"
    ? phoneNumber.slice(0, -2).replace(/./g, '*') + phoneNumber.slice(-2)
    : ''
  const email = formData?.email
  const maskedEmail = email && email !== "null"
    ? email.split('@')[0].slice(0, 3) + email.split('@')[0].slice(3).replace(/./g, '*') + '@' + email.split('@')[1]
    : ''

  // Handle input changes and clear corresponding errors
  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value })
    setErrors({ ...errors, [field]: '' })
  }

  return (
    <div className="container-fluid" style={{ padding: '10px 20px' }}>
      <div className="card">
        <LogoHeader />
      </div>
      <div
        className="mt-2 d-flex justify-content-center align-items-center"
        style={{ fontWeight: 'bold', fontSize: '25px' }}
      >
        Online Application Form For Admission To {GSteam.counsellingName} Courses {CURRENT_SESSION}
      </div>

      <div className="card ms-5 me-5 mt-3">
        <div className="card-body">
          <div className="row">
            <div className="col-12 d-flex justify-content-start">
              <th>Verification of Communication Details</th>
            </div>
          </div>
          <hr />
          {formData.phoneNumber !== "null" && formData.email !== "null" && formData.counsellingName !== "Post Diploma DNB" ? (
            <>
              <div className="row mt-2">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="Email">Email:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="Email"
                        value={maskedEmail}
                        readOnly
                      />
                      {errors.email && <div className="text-danger">{errors.email}</div>}
                    </div>
                    <div className="col">
                      <label htmlFor="phoneNumber">Mobile Number:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="phoneNumber"
                        value={maskedNumber}
                        readOnly
                      />
                      {errors.phoneNumber && <div className="text-danger">{errors.phoneNumber}</div>}
                    </div>
                  </div>

                  <div className="d-flex flex-column align-items-left">
                    <label style={{ color: 'red' }}>
                      <div>1. Same One Time Password (OTP) will be sent to the above mentioned email and mobile number.</div>
                      <div>2. Kindly make sure that mobile number is free from Do Not Disturb (DND) Facility.</div>
                    </label>
                  </div>
                  <hr />
                  <div className="m-3 text-left form-group">
                    <button
                      type="submit"
                      className="btn btn-sm btn-success text-white"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => handleInputChange('name', e.target.value)}
                  />
                  {errors.name && <div className="text-danger">{errors.name}</div>}
                </div>
                <div className="col">
                  <label>Father’s Name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => handleInputChange('fatherName', e.target.value)}
                  />
                  {errors.fatherName && <div className="text-danger">{errors.fatherName}</div>}
                </div>
                <div className="col">
                  <label>Mother’s Name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => handleInputChange('motherName', e.target.value)}
                  />
                  {errors.motherName && <div className="text-danger">{errors.motherName}</div>}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col">
                  <label>Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => handleInputChange('dob', e.target.value)}
                  />
                  {errors.dob && <div className="text-danger">{errors.dob}</div>}
                </div>
                <div className="col">
                  <label>Gender</label>
                  <select
                    className="form-control"
                    onChange={(e) => handleInputChange('gender', e.target.value)}
                  >
                    <option value="">Select Gender</option>
                    <option value="MALE">Male</option>
                    <option value="FEMALE">Female</option>
                    <option value="OTHER">Other</option>
                  </select>
                  {errors.gender && <div className="text-danger">{errors.gender}</div>}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col">
                  <label>Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                  />
                  {errors.phoneNumber && <div className="text-danger">{errors.phoneNumber}</div>}
                </div>
                <div className="col">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    onChange={(e) => handleInputChange('email', e.target.value)}
                  />
                  {errors.email && <div className="text-danger">{errors.email}</div>}
                </div>
              </div>
              <div className="m-3 text-left form-group">
                <button
                  type="submit"
                  className="btn btn-sm btn-primary text-white"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Send OTP'}
                </button>              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default RegistrationDetails